import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../../../styles/colors';
import { SPACING } from '../../../utils/layoutConstants';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	loadingContainer: {
		padding: SPACING.LG,
		textAlign: 'center',
		color: '#6B7280',
	},
	section: {
		marginTop: 14,
	},
	cancelOnReplySection: {
		marginTop: 0,
	},
	exitIfPolicyCanceledSection: {
		marginTop: 14,
	},
	householdsSection: {
		marginTop: 15,
	},
	checkboxText: {
		color: '#4a4a4a',
		fontSize: 14,
		marginBottom: 2,
		marginLeft: 16,
		whiteSpace: 'nowrap',
	},
	noMargin: {
		margin: 0,
	},
	advancedSection: {
		marginTop: SPACING.MD,
		paddingTop: SPACING.MD,
		borderTop: '1px solid #F2F2F2',
	},
	advancedContent: {
		marginTop: SPACING.MD,
	},
	advancedCheckboxText: {
		color: '#4a4a4a',
		fontSize: 14,
		margin: 0,
		marginLeft: 16,
		whiteSpace: 'nowrap',
	},
	viewCriteriaButton: {
		background: 'transparent',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		fontSize: 14,
		color: brandPrimary,
		marginTop: 14,
		marginLeft: 27,
		':hover': {
			textDecoration: 'underline',
		},
	},
	allowUnsubscribedCheckbox: {
		marginTop: 20,
	},
	helperText: {
		color: '#777',
		fontSize: 12,
		marginLeft: 26,
		marginTop: 4,
		lineHeight: 1.4,
	},
});
